import React, { FunctionComponent } from 'react';

import Text from '@gojob/ui-bits/Text';
import { titleLevel } from '../../../types/title';

export type TitleProps = {
  title?: string;
  level?: titleLevel;
};

const Title: FunctionComponent<TitleProps> = (props) => {
  const { title, level = 'h2' } = props;

  if (!title) {
    return null;
  }
  return (
    <Text variant="headline1" as={level} gutter={4} css={{ textAlign: 'center' }}>
      {title}
    </Text>
  );
};

export default Title;
